<template>
  <v-layout row>
    <v-flex xs12>
      <v-card class="elavation-1 transparent">
        <v-toolbar class="transparent" flat height="37">
            <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
        </v-toolbar>
      </v-card>
      <v-progress-linear indeterminate  v-if="loading"></v-progress-linear>
      
      <v-alert v-if="error" :value="true" color="error" icon="error" outline>
          {{errorMessage}}
      </v-alert>  

      <!-- colors, themes -->
      <v-card dense style="margin:5px 0px 5px 0px;">
        <v-toolbar flat height="35px">
            <span class="font-weight-bold ">Theme</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row >
            <v-flex shrink pa-1 >
                <v-list-tile-avatar class="text-xs-center" style="padding:10px; margin:10px 0px 0px 18px;">
                    <b>Color:</b>
                </v-list-tile-avatar>                    
            </v-flex>
            <v-flex grow pa-1>
                <div class="text-xs-left" style="padding:10px;margin-top:10px;">
                  <color-settings @send="updateHeaderImage"></color-settings> 
                </div>                     
            </v-flex>
        </v-layout>
        <v-layout row >
          <v-flex shrink pa-1>
              <v-list-tile-avatar class="text-xs-center" style="padding:10px; margin:10px 0px 0px 20px;">
                  <b>Mode:</b>
              </v-list-tile-avatar>           
          </v-flex>
          <v-flex grow pa-1>
              <div class="text-xs-left" style="padding:10px;margin:10px 0px 0px -3px;">
                <v-btn-toggle v-model="toggle_theme" dark>
                  <v-btn color="black" @click="updateTheme('dark')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
                  <v-btn color="white" @click="updateTheme('light')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
                </v-btn-toggle>   
              </div>
          </v-flex>
        </v-layout><br>
      </v-card>
     
      <!-- 2FA -->
      <v-card dense style="margin:0px 0px 10px 0px;">
        <v-toolbar flat height="35px">
            <span class="font-weight-bold ">2 Factor Authentication</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row >
          <v-flex style="margin:0 0 20px 35px;">
              <v-switch
                v-model="twoFA"
                label="2FA with OTP"
                color="primary"
                hide-details
                @change="updateTwoFA"
            ></v-switch>   
            <span class="caption grey--text" style="margin-left:45px;">Enabling 2FA is recommended</span>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- Notifications config -->
      <!-- for refactoring, notifications by app
      so each app will have its own app/email notification settings -->
      <v-card dense style="margin:0px 0px 10px 0px;">
        <v-toolbar flat height="35px">
            <span class="font-weight-bold ">Email and App Notification Settings</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row>
          <v-flex style="margin:5px 25px 0px 35px;">
            <p>
              Use the switches below to enable or disable Email and App notifications for the following features:<br>
              Attendance Corrections, Time Off, Overtime, Timesheet, Workshift Planning, Projects, Compensation and Benefits, Payroll, and Finance.
            </p>
            <p class="primary--text">
              <b>Note</b>: Notifications for Payslips, New Employee Creation, OTP, Password Reset, and New Device Login are always <b>enabled</b> and cannot be turned off.
            </p>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex style="margin:-25px 0px 0px 35px;">
              <v-switch
                v-model="appNotification"
                label="App"
                color="primary"
                hide-details
                @change="updateNotifications"
            ></v-switch>   
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex style="margin:-10px 0px 20px 35px;">
              <v-switch
                v-model="emailNotification"
                label="Email"
                color="primary"
                hide-details
                @change="updateNotifications"
            ></v-switch>   
          </v-flex>
        </v-layout>
      </v-card>

      <!-- change password -->
      <v-card dense>
        <v-toolbar flat height="35px">
            <span class="font-weight-bold ">Password</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row wrap>
          <v-flex xs12 sm3 style="margin:5px 20px 20px 25px;">
              <v-btn outline class="primary" :loading="loading" to="/changepassword">Change Password</v-btn>
          </v-flex>
          <v-flex xs12 sm3>
                
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

  </v-layout>  
</template>
<script>
    import userApi from '@/api/user.js'
    export default {  
      name: 'Settings',
      metaInfo: {
          title: 'My Settings',
          meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Change page primary color, change dark or light theme.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
      },
     components: {
       'color-settings': () => import('@/components/Settings/Colors')
    },      
    data () {
      return {
        loading: false,
        toggle_colors: null,
        toggle_theme: null,
        darkTheme: false,
        error: false,
        twoFA: null,
        appNotification: null,
        emailNotification: null,
        errorMessage: '', 
        headerImage: '',
        password: "test12345",
        showPassword: false,
        default_theme: 'light',
        rules: {
            required: value => !!value || "Required.",
            min: v => v.length >= 8 || "Min 8 characters",
            counter: value => value.length <= 20 || "Max 20 characters",
            email: value => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || "Invalid e-mail.";
            }
        },
      }
    },
    methods: {
      async showHidePassword() {
        if (!this.showPassword) {
          
          this.showPassword = true
        }else{
          this.showPassword = false
        }
      },
      async updateTwoFA() {
        try {  
          const data = {twoFA: this.twoFA}
          await userApi.updateTwoFA(data); 
          this.$store.commit('setTwoFA', this.twoFA)
        }
        catch(error) {
          this.error = true
          this.errorMessage = error
        }
      },
      async updateNotifications() {
        try {  
          const data = {
            appNotification: this.appNotification,
            emailNotification: this.emailNotification
          }
          await userApi.updateNotifications(data); 
          this.$store.commit('setAppNotification', this.appNotification)
          this.$store.commit('setEmailNotification', this.emailNotification)
        } catch(error) {
          this.error = true
          this.errorMessage = error
        }
      },
      updateHeaderImage(color){
        this.headerImage = color.toLowerCase() + '.jpg'
        this.$store.commit('setHeaderImage', this.headerImage)

        //update main header image
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Settings',
            headerImgPath: this.headerImage
        })
      },
      async updateTheme(theme) {
        this.$root.$emit('updateTheme', theme)
        this.$store.commit('setTheme', theme)  
      }
    },
    created() {
      this.$root.$emit('setHeaderTitles', {
        display: true,
        headerTitle: '',
        headerPageTitle: 'Settings'
      })
      this.headerImage = this.$store.state.headerImg.replace('.darken1','').replace('.darken2','').replace('.darken3','').replace('.darken4','')
      this.twoFA = this.$store.state.twoFA
      this.appNotification = this.$store.state.appNotification
      this.emailNotification = this.$store.state.emailNotification
    },
    computed: {},
    beforeDestroy() {}
  }
</script>